import { attach } from 'effector';

import { api } from '@shared/api';

const resetMFAFx = attach({ effect: api.auth.resetMfa });

export { resetMFAFx };
